<template>
  <div class="ConditionLabel" :class="`status-${status}`">
    <span class="label">{{ displayedStatus }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { CONDITION_LABEL } from './constants'

export default defineComponent({
  props: {
    status: {
      type: String as () => keyof typeof CONDITION_LABEL,
      required: true,
    }
  },
  setup(props) {
    const displayedStatus = computed(
      () => CONDITION_LABEL[props.status] || ''
    )

    return {
      displayedStatus,
    }
  }
})
</script>

<style scoped>
.ConditionLabel {
  border-radius: 4px;
  padding: 0 8px;
  box-sizing: border-box;
}

.ConditionLabel.status-s {
  border: 1px solid var(--primitive-colors-basic-lightblue-500);
  background: var(--primitive-colors-basic-lightblue-100);
  color: var(--primitive-colors-basic-lightblue-600);
}

.ConditionLabel.status-a {
  border: 1px solid var(--primitive-colors-system-green-500);
  background: var(--primitive-colors-system-green-100);
  color: var(--primitive-colors-system-green-600);
}

.ConditionLabel.status-b {
  border: 1px solid var(--primitive-colors-system-orange-500);
  background: var(--primitive-colors-system-orange-100);
  color: var(--primitive-colors-system-orange-600);
}

.ConditionLabel.status-c {
  border: 1px solid var(--primitive-colors-system-red-500);
  background: var(--primitive-colors-system-red-100);
  color: var(--primitive-colors-system-red-600);
}

.ConditionLabel .label {
  text-align: center;
  font-size: var(--font-size-capture-2);
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.11px;
  display: block;
}
</style>